var _defs, _rect, _rect2, _text, _rect3, _text2, _text3, _rect4, _text4, _rect5, _text5, _rect6, _text6, _rect7, _text7, _rect8, _text8, _text9, _text0, _rect9, _text1, _text10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramArchitecture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 420,
    viewBox: "0 0 900 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 900,
    y2: 420
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#34D399",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#60A5FA",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    y1: 0,
    x2: 900,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0EA5E9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#22D3EE",
    stopOpacity: 0.8
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 880,
    height: 400,
    rx: 24,
    fill: "#0B0F18",
    stroke: "#1F2937"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 150,
    height: 56,
    rx: 14,
    fill: "#111827",
    stroke: "#253043"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 74,
    fill: "#E2E8F0",
    fontSize: 14,
    fontFamily: "DM Sans, Arial"
  }, "User Input")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 40,
    width: 200,
    height: 70,
    rx: 16,
    fill: "#111827",
    stroke: "#3B82F6"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 82,
    fill: "#E2E8F0",
    fontSize: 15,
    fontFamily: "DM Sans, Arial"
  }, "Orchestrator")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 100,
    fill: "#94A3B8",
    fontSize: 11,
    fontFamily: "DM Sans, Arial"
  }, "retrieval \xB7 scheduling \xB7 compression")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 35,
    width: 200,
    height: 60,
    rx: 16,
    fill: "#111827",
    stroke: "#22D3EE"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 634,
    y: 70,
    fill: "#E2E8F0",
    fontSize: 14,
    fontFamily: "DM Sans, Arial"
  }, "Planner Agent")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 110,
    width: 200,
    height: 60,
    rx: 16,
    fill: "#111827",
    stroke: "#22D3EE"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 145,
    fill: "#E2E8F0",
    fontSize: 14,
    fontFamily: "DM Sans, Arial"
  }, "Critic Agent")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 180,
    width: 170,
    height: 60,
    rx: 16,
    fill: "#111827",
    stroke: "#34D399"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 215,
    fill: "#E2E8F0",
    fontSize: 14,
    fontFamily: "DM Sans, Arial"
  }, "Retrieval Agent")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 200,
    width: 200,
    height: 60,
    rx: 16,
    fill: "#111827",
    stroke: "#34D399"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 628,
    y: 235,
    fill: "#E2E8F0",
    fontSize: 14,
    fontFamily: "DM Sans, Arial"
  }, "Compression Agent")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 250,
    width: 300,
    height: 120,
    rx: 18,
    fill: "#0F172A",
    stroke: "#1E293B"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 280,
    fill: "#E2E8F0",
    fontSize: 14,
    fontFamily: "DM Sans, Arial"
  }, "Memory Tiers")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 305,
    fill: "#94A3B8",
    fontSize: 12,
    fontFamily: "DM Sans, Arial"
  }, "STM \xB7 CWM \xB7 LTM")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 330,
    fill: "#94A3B8",
    fontSize: 12,
    fontFamily: "DM Sans, Arial"
  }, "MongoDB + snapshots")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 300,
    width: 180,
    height: 60,
    rx: 16,
    fill: "#111827",
    stroke: "#1F2937"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 335,
    fill: "#E2E8F0",
    fontSize: 14,
    fontFamily: "DM Sans, Arial"
  }, "Event Log")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 352,
    fill: "#94A3B8",
    fontSize: 11,
    fontFamily: "DM Sans, Arial"
  }, "deterministic audit trail")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 68 L350 76",
    stroke: "url(#g1)",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M550 76 L610 65",
    stroke: "url(#g1)",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550 95 L610 125",
    stroke: "url(#g1)",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350 110 L200 180",
    stroke: "url(#g1)",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550 110 L610 210",
    stroke: "url(#g1)",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155 240 L300 290",
    stroke: "url(#g2)",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M610 230 L600 300",
    stroke: "url(#g2)",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300 310 L220 330",
    stroke: "url(#g2)",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramArchitecture);
export default __webpack_public_path__ + "static/media/diagram-architecture.0f86100bcdf8db7be9524f5deb85f4a6.svg";
export { ForwardRef as ReactComponent };